import { DEFAULT_MARGIN_XL, DEFAULT_MARGIN_S } from "@src/common/styles/const";
import styled from "styled-components";

export const ImpersonateDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${DEFAULT_MARGIN_S}px;
  margin-bottom: ${DEFAULT_MARGIN_XL}px;
`;
